import styles from "./Text.module.scss";
import { TextOptionsType } from "@/types/ModuleOptionsType";
import { columnSize } from "../../utils/layout/columnSize";
import { Modul_Text } from "../../wp/types/acf-module-types";
import { useSublinesVisibility } from "../../hooks/useSublinesOverlinesVisibility";
import { checkModuleIsHidden } from "@/utils/checkModuleIsHidden";
import { Section } from "@/components/Section/Section";
import { FadeInUp } from "@/components/Animation/ScrollAnimation";
import { Content } from "@/components/Content/Content";

export type TextModuleType = Modul_Text;

interface TextProps {
  data: TextModuleType;
  textOptions: TextOptionsType;
  isBigParagraph?: boolean;
}

const Text = ({ data, textOptions, isBigParagraph }: TextProps) => {
  const {
    headline_text_align_class,
    text_align_class,
    section_padding_class,
    section_margin_class,
    background_color_class,
    id,
    module_width,
  } = data.layout;

  const { button_type, columns, show_extended_link, show_overline_subline } =
    textOptions;
  const {
    headline,
    headline_html_tag,
    link,
    content,
    content_2,
    link_2,
    number_columns,
    overline,
    subline,
    link_extended,
    link_2_extended,
  } = data.text;

  const { showOverline, showSubline } = useSublinesVisibility(
    show_overline_subline ?? "none",
  );

  {
    /* jscpd:ignore-start */
  }
  //! check if module is hidden
  const isHidden = checkModuleIsHidden(data.settings);
  if (isHidden) {
    return null;
  }
  {
    /* jscpd:ignore-end */
  }

  return (
    <Section
      className={`${styles.text} ${id ?? ""} ${background_color_class} ${section_padding_class} ${section_margin_class} ${isBigParagraph ? "big-paragraph" : ""}`}
      columnsClassName="is-centered"
      id={id}
      frameless={module_width === "frameless"}
    >
      <div
        className={`column ${module_width === "narrow-frame" ? columnSize(columns) : "is-12"} is-centered`}
      >
        <FadeInUp>
          <Content
            headline_text_align_class={headline_text_align_class ?? ""}
            text_align_class={text_align_class ?? ""}
            headline_html_tag={headline_html_tag}
            headline={headline}
            text={content || ""}
            link={!show_extended_link ? link : false}
            button_type={button_type}
            content_two_columns={number_columns === "two-cols"}
            text_2={content_2}
            link_2={!show_extended_link ? link_2 : false}
            overline={showOverline ? overline : ""}
            subline={showSubline ? subline : ""}
            link_extended={show_extended_link ? link_extended : false}
            link_2_extended={show_extended_link ? link_2_extended : false}
            frameless={module_width === "frameless"}
          />
        </FadeInUp>
      </div>
    </Section>
  );
};

export default Text;
